import Icon from '../components/Icon.vue'

Icon.register({
  ribbon: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M6.1 444.3l117.2-130 79.2 87.9-91.8 101.9c-8 8.8-21.4 10.5-31.3 3.8l-68.8-27.9c-12-8.1-14.1-24.9-4.5-35.7zM441.9 444.3c9.7 10.8 7.6 27.6-4.3 35.6l-68.8 27.9c-9.9 6.7-23.3 5.1-31.3-3.8l-248.1-275.3c-48.6-53.8-13-113.5-11.5-116l43.6-73.2c4.3-7.2 9.9-13.3 16.8-18 44-29.7 130.7-27.6 171.4 0 6.9 4.7 12.5 10.8 16.8 18l43.7 73.5c21.9 36.9 17.3 83.6-11.4 115.5l-34.2 38-79.1-87.7s52.7-59 56-64.6c-15.4-8.4-40.2-17.9-77.5-17.9s-62.1 9.5-77.5 17.9c3.4 5.5 295.4 330.1 295.4 330.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ribbon.js
// module id = 1841
// module chunks = 0